import classNames from 'classnames';
import React, { FC, ReactElement } from 'react';

interface CardProps {
  heading: string | ReactElement;
  body: string | ReactElement;
  className?: string;
}

export const Card: FC<CardProps> = (props) => {
  const { heading, body, className } = props;

  return (
    <div className={classNames("insuranceCard", className)}>
      <div className="card__heading">
        {heading}
      </div>
      <div className="card__body">
        {body}
      </div>
    </div>
  )
};
